import { CalendarIcon } from "@radix-ui/react-icons";
import { formatInTimeZone } from "date-fns-tz";
import type * as React from "react";

import { Button, type ButtonProps } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { cn } from "@/lib/utils";

export function DatePicker({
  inputDate,
  onSelect,
  className,
  style,
  variant = "ghost",
  disabled = false,
}: {
  inputDate: Date | null;
  onSelect: (value: any) => void;
  className?: ButtonProps["className"];
  style?: React.CSSProperties;
  variant?: ButtonProps["variant"];
  disabled?: boolean;
}) {
  const timeZone = "Europe/Berlin";

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={variant}
          className={cn(
            "w-[240px] justify-start text-left font-normal",
            !inputDate && "text-muted-foreground",
            className,
          )}
          style={style}
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {inputDate ? (
            formatInTimeZone(inputDate, timeZone, "dd.MM.yyyy")
          ) : (
            <span>Datum</span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={inputDate ?? undefined}
          onSelect={onSelect}
          disabled={disabled}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
